import { render, staticRenderFns } from "./personal-details-tab.html?vue&type=template&id=1a8b5385&scoped=true&"
import script from "./personal-details-tab.js?vue&type=script&lang=js&"
export * from "./personal-details-tab.js?vue&type=script&lang=js&"
import style0 from "./personal-details-tab.scss?vue&type=style&index=0&id=1a8b5385&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8b5385",
  null
  
)

export default component.exports